/* Universal date/time formatting helpers used across all Probe screens.
 *
 * Standard display format: `DD MMM YYYY HH:MM:SS` (24-hour, UTC offset-aware).
 * Example: "17 Feb 2026 09:31:42".
 *
 * Compact (no seconds) variant: `DD MMM YYYY HH:MM`.
 */

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const pad = (n) => String(n).padStart(2, "0");

const _safeDate = (input) => {
  if (input == null || input === "") return null;
  if (input instanceof Date) return isNaN(input.getTime()) ? null : input;
  const d = new Date(input);
  return isNaN(d.getTime()) ? null : d;
};

/** Full timestamp: "DD MMM YYYY HH:MM:SS" (24-hour, local TZ). */
export function formatDateTime(input) {
  const d = _safeDate(input);
  if (!d) return "—";
  return `${pad(d.getDate())} ${MONTHS[d.getMonth()]} ${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

/** Compact timestamp without seconds: "DD MMM YYYY HH:MM". */
export function formatDateTimeShort(input) {
  const d = _safeDate(input);
  if (!d) return "—";
  return `${pad(d.getDate())} ${MONTHS[d.getMonth()]} ${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** Date only: "DD MMM YYYY". */
export function formatDate(input) {
  const d = _safeDate(input);
  if (!d) return "—";
  return `${pad(d.getDate())} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

/** Relative duration in milliseconds: "350ms", "2.4s", "1m 04s", "1h 02m". */
export function formatDuration(ms) {
  if (ms == null) return "—";
  if (ms < 1000) return `${ms}ms`;
  const s = Math.round(ms / 100) / 10;
  if (s < 60) return `${s}s`;
  const totalSec = Math.round(s);
  const m = Math.floor(totalSec / 60);
  const rem = totalSec % 60;
  if (m < 60) return `${m}m ${pad(rem)}s`;
  const h = Math.floor(m / 60);
  return `${h}h ${pad(m % 60)}m`;
}
